var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c("w-select", {
        staticClass: "mr",
        style: { flexGrow: 1 },
        attrs: {
          items: _vm.items.reverse(),
          fancy: "",
          label: _vm.label,
          disabled: _vm.disabled,
        },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
      _c(
        "w-button",
        {
          attrs: { disabled: _vm.disabled },
          on: {
            click: function ($event) {
              return _vm.add()
            },
          },
        },
        [_c("w-fa", { attrs: { icon: "plus" } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }